// 전화 칸 형식 — 숫자·하이픈·공백·괄호·+ 만, 숫자는 8~13자리(1588-0000 ~ +82-10-0000-0000).
export const PHONE_FORMAT_MESSAGE = "전화는 숫자·하이픈으로 적어 주세요 (예: 02-000-0000)";

const PHONE_DIGITS_MAX = 13;

export const isPhoneFormat = (value: string): boolean => {
  const trimmed = value.trim();
  if (!/^\+?[\d\s()-]+$/.test(trimmed)) return false;
  const digits = trimmed.replace(/\D/g, "").length;
  return digits >= 8 && digits <= PHONE_DIGITS_MAX;
};

const PHONE_RUN = /[+(]?\d[\d() \t-]*[\d)](?:[ \t]*-)*/g;
const DOUBLED_HYPHEN = /[\d)][ \t]*-[ \t]*-/;
// 접은 결과가 한 번호 꼴(국번-3~4자리-4자리)일 때만 접는다 — 「02-555-1234 -- 12」 처럼 덧붙은 숫자를 번호에 붙이지 않는다.
const ONE_PHONE = /^(?:\+82[ -]?)?\(?0?\d{1,3}\)?[ -]?\d{3,4}[ -]?\d{4}$/;
// 오타로 겹친 하이픈(「010--1234」「02 - - 555」)이 든 번호 한 덩이만 하이픈 하나로 접고 끝에 남은 하이픈을 걷는다 — 두 번호가 이어진 꼴은 그대로 둔다.
export const collapsePhoneSeparators = (value: string): string =>
  value.replace(PHONE_RUN, (run) => {
    const core = run.replace(/(?:[ \t]*-)+$/, "");
    if (!DOUBLED_HYPHEN.test(core) || core.replace(/\D/g, "").length > PHONE_DIGITS_MAX) return run;
    const collapsed = core.replace(/([\d)])[ \t]*(?:-[ \t]*)+(?=[\d(])/g, "$1-");
    return ONE_PHONE.test(collapsed) ? collapsed : run;
  });
